import { foreignKey, pgTable, text, unique, uniqueIndex, uuid, } from 'drizzle-orm/pg-core';
import { orgPrimaryKey, orgTableBase } from '../org-id';
import { configColumn, defaultLayer } from '../../json';
import { sortOrder } from '../../utils';
import { Tag } from '../tag';
import { relations, sql } from 'drizzle-orm';
import { Team } from '../roster/team';
import { RecordType } from '../../enums';
export const WorkoutTemplate = pgTable('workout_template', {
    ...orgTableBase,
    name: text('name').notNull(),
    // multiple layers can be saved in the same template
    template: configColumn('template', defaultLayer)
        .array()
        .notNull(),
    exerciseIds: uuid('exercise_ids').array().notNull(),
    teamId: uuid('team_id'),
    recordType: RecordType('record_type'),
}, (table) => ({
    pk: orgPrimaryKey(table),
    uq: unique().on(table.orgId, table.name, table.teamId),
    // The (orgId, name, teamId) unique constraint above does not catch
    // duplicate org-scoped names: Postgres treats NULLs as distinct, so two
    // rows with teamId IS NULL and the same name both pass. This partial
    // unique index enforces name uniqueness for the org-level (teamId IS
    // NULL) template library at the database level, closing the
    // concurrent-save race the application-level preflight check can't.
    orgNameUqIdx: uniqueIndex('workout_template_org_name_uq_idx')
        .on(table.orgId, table.name)
        .where(sql `${table.teamId} IS NULL`),
    teamFk: foreignKey({
        columns: [table.orgId, table.teamId],
        foreignColumns: [Team.orgId, Team.id],
    }),
}));
export const WorkoutTemplate_Relations = relations(WorkoutTemplate, ({ many, one }) => ({
    tags: many(WorkoutTemplateTag),
    team: one(Team, {
        fields: [WorkoutTemplate.orgId, WorkoutTemplate.teamId],
        references: [Team.orgId, Team.id],
    }),
}));
export const WorkoutTemplateTag = pgTable('workout_template_tag', {
    ...orgTableBase,
    workoutTemplateId: uuid('workout_template_id').notNull(),
    tagId: uuid('tag_id').notNull(),
    sortOrder,
}, (table) => ({
    pk: orgPrimaryKey(table),
    uq: unique().on(table.orgId, table.workoutTemplateId, table.tagId),
    uq2: unique().on(table.orgId, table.workoutTemplateId, table.sortOrder),
    templateFk: foreignKey({
        columns: [table.orgId, table.workoutTemplateId],
        foreignColumns: [WorkoutTemplate.orgId, WorkoutTemplate.id],
    }),
    tagFk: foreignKey({
        columns: [table.orgId, table.tagId],
        foreignColumns: [Tag.orgId, Tag.id],
    }),
}));
export const WorkoutTemplateTag_Relations = relations(WorkoutTemplateTag, ({ one }) => ({
    template: one(WorkoutTemplate, {
        fields: [WorkoutTemplateTag.orgId, WorkoutTemplateTag.workoutTemplateId],
        references: [WorkoutTemplate.orgId, WorkoutTemplate.id],
    }),
    tag: one(Tag, {
        fields: [WorkoutTemplateTag.orgId, WorkoutTemplateTag.tagId],
        references: [Tag.orgId, Tag.id],
    }),
}));
//# sourceMappingURL=workout-template.js.map